import { User } from "@twilio/conversations";

/**
 * Gets agents firstname from two separate formats. "Smith, John" and "John Smith".
 * for sso or console login users. Checks for sso formatted name first.
 * @param users
 * @param participant
 * @returns
 */
const getAgentFirstName = (users: User[] | undefined, participant: string): string | undefined => {
    const friendlyName = users?.find((user) => user.identity === participant)?.friendlyName?.trim();

    if (!friendlyName) return undefined;

    return friendlyName.includes(",")
        ? friendlyName.split(",")[1]?.trim() // sso format user check
        : friendlyName.split(/\s+/)[0]; // console format user check
};

export default getAgentFirstName;
